import * as React from 'react';
import cn from 'classnames';
import ButtonBase from '@mui/material/ButtonBase';
import { OauthServiceType } from '@websky/graphql';
import { useTheme } from '../../theme';
import { useConfig } from '../../context';
import { icons } from '../../Account/components/SocialAuth/icons';
import { useRedirectToService } from './hooks';
const SocialAuth = ({ variant = 'common', onClick }) => {
    const { global: { socialAuthMethods } } = useConfig();
    const { SocialAuth: css } = useTheme('SocialAuth');
    const redirectToService = useRedirectToService();
    return (React.createElement("div", { className: cn(css.wrapper, { [css.wrapper_square]: variant === 'square' }), "data-social-auth": true }, socialAuthMethods
        .filter(method => method.isAvailable)
        .map(method => (React.createElement(ButtonBase, { key: method.service, "data-oauth-type": method.service, className: cn(css.button, {
            [css.button_light]: method.service === OauthServiceType.Vkontakte ||
                method.service === OauthServiceType.Facebook ||
                method.service === OauthServiceType.TinkoffID,
            [css.button_facebook]: method.service === OauthServiceType.Facebook,
            [css.button_google]: method.service === OauthServiceType.Google
        }), onClick: () => redirectToService({
            service: OauthServiceType[method.service],
            callback: onClick
        }) }, icons[method.service])))));
};
export default SocialAuth;
